@import '../general';
@import 'tab-bar';

.cmp-db-tab {
  display: contents;
}
